// Nombres y apellidos para generar usuarios
const nombres = ['Juan', 'María', 'Pedro', 'Ana', 'Carlos', 'Sofía', 'Diego', 'Valentina', 'Miguel', 'Isabella', 'José', 'Camila', 'Luis', 'Martina', 'Jorge', 'Emma', 'Roberto', 'Lucía', 'Fernando', 'Victoria', 'Andrés', 'Daniela', 'Francisco', 'Amanda', 'Ricardo', 'Carolina', 'Manuel', 'Gabriela', 'Antonio', 'Paula'];
const apellidos = ['González', 'Rodríguez', 'Pérez', 'López', 'Martínez', 'García', 'Fernández', 'Sánchez', 'Ramírez', 'Torres', 'Flores', 'Rivera', 'Gómez', 'Díaz', 'Muñoz', 'Rojas', 'Silva', 'Morales', 'Campos', 'Vargas', 'Castro', 'Ortiz', 'Núñez', 'Herrera', 'Medina', 'Gutiérrez', 'Jiménez', 'Navarro', 'Peña', 'Vega'];

// Función para generar RUT aleatorio
const generarRUT = (id) => {
  const base = 10000000 + id * 137;
  const rut = base.toString();
  const dv = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'K'][base % 11];
  return `${rut.slice(0, 2)}.${rut.slice(2, 5)}.${rut.slice(5, 8)}-${dv}`;
};

// Función para generar teléfono aleatorio
const generarTelefono = (id) => {
  const numero = 900000000 + (id * 12345) % 99999999;
  const tel = numero.toString();
  return `+56 9 ${tel.slice(1, 5)} ${tel.slice(5, 9)}`;
};

// Generar usuarios mock
const generarUsuariosMock = () => {
  const usuarios = [
    // Usuarios base para testing
    {
      id: 1,
      email: 'admin@educapp.cl',
      password: 'admin123',
      role: 'administrador',
      name: 'Juan Carlos Pérez',
      rut: '12.345.678-9',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
      phone: '+56 9 8765 4321',
      address: 'Av. Principal 123, Santiago',
      status: 'activo',
      createdAt: '2024-01-15',
      permissions: ['all']
    },
    {
      id: 2,
      email: 'gestor@educapp.cl',
      password: 'gestor123',
      role: 'gestor',
      name: 'Ana María González',
      rut: '13.456.789-0',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616c3c611cb?w=40&h=40&fit=crop&crop=face',
      phone: '+56 9 7654 3210',
      address: 'Calle Secundaria 456, Santiago',
      status: 'activo',
      createdAt: '2024-02-10',
      permissions: ['users', 'courses', 'projects', 'calendar']
    },
    {
      id: 3,
      email: 'profesor@educapp.cl',
      password: 'prof123',
      role: 'profesor',
      name: 'María José Rodríguez',
      rut: '14.567.890-1',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face',
      phone: '+56 9 6543 2109',
      address: 'Pasaje Educación 789, Santiago',
      status: 'activo',
      createdAt: '2024-03-05',
      subjects: ['Matemáticas', 'Ciencias'],
      permissions: ['projects', 'evaluations', 'messages']
    },
    {
      id: 4,
      email: 'alumno@educapp.cl',
      password: 'alum123',
      role: 'alumno',
      name: 'Carlos Eduardo Silva',
      rut: '20.123.456-7',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face',
      phone: '+56 9 5432 1098',
      address: 'Villa Estudiantil 321, Santiago',
      status: 'activo',
      createdAt: '2024-03-20',
      course: '8° Básico A',
      permissions: ['projects', 'grades', 'messages']
    },
    {
      id: 5,
      email: 'apoderado@educapp.cl',
      password: 'apod123',
      role: 'apoderado',
      name: 'Patricia Elena Morales',
      rut: '11.234.567-8',
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=40&h=40&fit=crop&crop=face',
      phone: '+56 9 4321 0987',
      address: 'Barrio Familiar 654, Santiago',
      status: 'activo',
      createdAt: '2024-03-25',
      children: [{ id: 4, name: 'Carlos Eduardo Silva', course: '8° Básico A' }],
      permissions: ['messages', 'payments', 'reports']
    }
  ];

  // Roles disponibles con sus pesos (más alumnos y profesores)
  const rolesDistribucion = [
    { role: 'administrador', weight: 2, permissions: ['all'] },
    { role: 'gestor', weight: 3, permissions: ['users', 'courses', 'projects', 'calendar'] },
    { role: 'profesor', weight: 10, permissions: ['projects', 'evaluations', 'messages'] },
    { role: 'alumno', weight: 20, permissions: ['projects', 'grades', 'messages'] },
    { role: 'apoderado', weight: 10, permissions: ['messages', 'payments', 'reports'] }
  ];

  const comunas = ['Santiago', 'Providencia', 'Las Condes', 'Ñuñoa', 'Maipú', 'La Florida', 'Puente Alto', 'San Bernardo', 'Peñalolén', 'Quilicura'];
  const calles = ['Av. Libertador', 'Calle Los Aromos', 'Pasaje Central', 'Av. Apoquindo', 'Calle Nueva', 'Av. Vicuña Mackenna', 'Calle Los Olivos', 'Av. Grecia', 'Pasaje Las Rosas', 'Calle San Martín'];

  // Generar 40 usuarios adicionales
  for (let i = 6; i <= 45; i++) {
    const nombre1 = nombres[Math.floor(Math.random() * nombres.length)];
    const nombre2 = Math.random() > 0.5 ? nombres[Math.floor(Math.random() * nombres.length)] : '';
    const apellido1 = apellidos[Math.floor(Math.random() * apellidos.length)];
    const apellido2 = apellidos[Math.floor(Math.random() * apellidos.length)];
    const nombreCompleto = `${nombre1}${nombre2 ? ' ' + nombre2 : ''} ${apellido1} ${apellido2}`;

    // Seleccionar rol basado en distribución
    const random = Math.random() * 45; // Total weight
    let acumulado = 0;
    let rolSeleccionado = rolesDistribucion[0];

    for (const rolData of rolesDistribucion) {
      acumulado += rolData.weight;
      if (random <= acumulado) {
        rolSeleccionado = rolData;
        break;
      }
    }

    const email = `${nombre1.toLowerCase()}.${apellido1.toLowerCase()}${i}@educapp.cl`;
    const comuna = comunas[Math.floor(Math.random() * comunas.length)];
    const calle = calles[Math.floor(Math.random() * calles.length)];
    const numero = Math.floor(Math.random() * 9000) + 1000;
    const status = Math.random() > 0.15 ? 'activo' : 'inactivo'; // 85% activos

    // Fechas aleatorias en 2024
    const mes = Math.floor(Math.random() * 12) + 1;
    const dia = Math.floor(Math.random() * 28) + 1;
    const createdAt = `2024-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;

    const usuario = {
      id: i,
      email,
      password: 'password123',
      role: rolSeleccionado.role,
      name: nombreCompleto,
      rut: generarRUT(i),
      avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(nombreCompleto)}&background=random`,
      phone: generarTelefono(i),
      address: `${calle} ${numero}, ${comuna}`,
      status,
      createdAt,
      permissions: rolSeleccionado.permissions
    };

    // Agregar campos específicos por rol
    if (rolSeleccionado.role === 'profesor') {
      const materias = [['Matemáticas'], ['Lenguaje'], ['Ciencias'], ['Historia'], ['Inglés'], ['Matemáticas', 'Física'], ['Química', 'Biología']];
      usuario.subjects = materias[Math.floor(Math.random() * materias.length)];
    } else if (rolSeleccionado.role === 'alumno') {
      const cursos = ['7° Básico A', '7° Básico B', '8° Básico A', '8° Básico B', '1° Medio A', '1° Medio B', '2° Medio A', '3° Medio A', '4° Medio A'];
      usuario.course = cursos[Math.floor(Math.random() * cursos.length)];
    } else if (rolSeleccionado.role === 'apoderado') {
      usuario.children = [];
    }

    usuarios.push(usuario);
  }

  return usuarios;
};

let mockUsersData = generarUsuariosMock();

// Simular delay de red
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

class UserService {
  constructor() {
    this.nextId = 46; // Siguiente ID disponible
  }

  // Obtener todos los usuarios
  async getUsers(filters = {}) {
    await delay(300);

    let users = [...mockUsersData];

    // Aplicar filtros
    if (filters.role && filters.role !== 'todos') {
      users = users.filter(u => u.role === filters.role);
    }

    if (filters.status && filters.status !== 'todos') {
      users = users.filter(u => u.status === filters.status);
    }

    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      users = users.filter(u =>
        u.name.toLowerCase().includes(searchLower) ||
        u.email.toLowerCase().includes(searchLower) ||
        u.rut.includes(filters.search)
      );
    }

    // Remover contraseñas de la respuesta
    users = users.map(u => {
      const { password, ...userWithoutPassword } = u;
      return userWithoutPassword;
    });

    return {
      success: true,
      data: users,
      total: users.length
    };
  }

  // Obtener un usuario por ID
  async getUserById(id) {
    await delay(300);

    const user = mockUsersData.find(u => u.id === parseInt(id));

    if (!user) {
      return {
        success: false,
        message: 'Usuario no encontrado'
      };
    }

    // Remover contraseña de la respuesta
    const { password, ...userWithoutPassword } = user;

    return {
      success: true,
      data: userWithoutPassword
    };
  }

  // Crear nuevo usuario
  async createUser(userData) {
    await delay(500);

    try {
      // Validar email único
      const emailExists = mockUsersData.some(u => u.email === userData.email);
      if (emailExists) {
        return {
          success: false,
          message: 'El email ya está registrado'
        };
      }

      // Validar RUT único
      const rutExists = mockUsersData.some(u => u.rut === userData.rut);
      if (rutExists) {
        return {
          success: false,
          message: 'El RUT ya está registrado'
        };
      }

      // Crear nuevo usuario
      const newUser = {
        id: this.nextId++,
        ...userData,
        status: userData.status || 'activo',
        createdAt: new Date().toISOString().split('T')[0],
        avatar: userData.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(userData.name)}&background=random`
      };

      mockUsersData.push(newUser);

      // Remover contraseña de la respuesta
      const { password, ...userWithoutPassword } = newUser;

      return {
        success: true,
        data: userWithoutPassword,
        message: 'Usuario creado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al crear usuario'
      };
    }
  }

  // Actualizar usuario
  async updateUser(id, userData) {
    await delay(500);

    try {
      const userIndex = mockUsersData.findIndex(u => u.id === parseInt(id));

      if (userIndex === -1) {
        return {
          success: false,
          message: 'Usuario no encontrado'
        };
      }

      // Si se está actualizando el email, verificar que no exista
      if (userData.email && userData.email !== mockUsersData[userIndex].email) {
        const emailExists = mockUsersData.some(u => u.email === userData.email && u.id !== parseInt(id));
        if (emailExists) {
          return {
            success: false,
            message: 'El email ya está registrado'
          };
        }
      }

      // Si se está actualizando el RUT, verificar que no exista
      if (userData.rut && userData.rut !== mockUsersData[userIndex].rut) {
        const rutExists = mockUsersData.some(u => u.rut === userData.rut && u.id !== parseInt(id));
        if (rutExists) {
          return {
            success: false,
            message: 'El RUT ya está registrado'
          };
        }
      }

      // Actualizar usuario
      mockUsersData[userIndex] = {
        ...mockUsersData[userIndex],
        ...userData,
        id: parseInt(id) // Asegurar que el ID no cambie
      };

      // Remover contraseña de la respuesta
      const { password, ...userWithoutPassword } = mockUsersData[userIndex];

      return {
        success: true,
        data: userWithoutPassword,
        message: 'Usuario actualizado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al actualizar usuario'
      };
    }
  }

  // Eliminar usuario
  async deleteUser(id) {
    await delay(500);

    const userIndex = mockUsersData.findIndex(u => u.id === parseInt(id));

    if (userIndex === -1) {
      return {
        success: false,
        message: 'Usuario no encontrado'
      };
    }

    // No permitir eliminar al admin principal
    if (mockUsersData[userIndex].email === 'admin@educapp.cl') {
      return {
        success: false,
        message: 'No se puede eliminar el usuario administrador principal'
      };
    }

    mockUsersData.splice(userIndex, 1);

    return {
      success: true,
      message: 'Usuario eliminado exitosamente'
    };
  }

  // Cambiar estado del usuario (activo/inactivo)
  async toggleUserStatus(id) {
    await delay(300);

    const userIndex = mockUsersData.findIndex(u => u.id === parseInt(id));

    if (userIndex === -1) {
      return {
        success: false,
        message: 'Usuario no encontrado'
      };
    }

    // No permitir desactivar al admin principal
    if (mockUsersData[userIndex].email === 'admin@educapp.cl') {
      return {
        success: false,
        message: 'No se puede desactivar el usuario administrador principal'
      };
    }

    const newStatus = mockUsersData[userIndex].status === 'activo' ? 'inactivo' : 'activo';
    mockUsersData[userIndex].status = newStatus;

    return {
      success: true,
      data: { status: newStatus },
      message: `Usuario ${newStatus === 'activo' ? 'activado' : 'desactivado'} exitosamente`
    };
  }

  // Cambiar contraseña de usuario
  async changeUserPassword(id, newPassword) {
    await delay(400);

    const userIndex = mockUsersData.findIndex(u => u.id === parseInt(id));

    if (userIndex === -1) {
      return {
        success: false,
        message: 'Usuario no encontrado'
      };
    }

    mockUsersData[userIndex].password = newPassword;

    return {
      success: true,
      message: 'Contraseña actualizada exitosamente'
    };
  }

  // Obtener roles disponibles
  getRoles() {
    return [
      { value: 'administrador', label: 'Administrador', permissions: ['all'] },
      { value: 'gestor', label: 'Gestor', permissions: ['users', 'courses', 'projects', 'calendar', 'evaluations', 'messages', 'reports'] },
      { value: 'profesor', label: 'Profesor', permissions: ['projects', 'courses', 'evaluations', 'messages', 'calendar', 'grades'] },
      { value: 'alumno', label: 'Alumno', permissions: ['projects', 'grades', 'messages', 'calendar'] },
      { value: 'apoderado', label: 'Apoderado', permissions: ['messages', 'payments', 'reports', 'calendar'] }
    ];
  }

  // Obtener permisos por rol
  getPermissionsByRole(role) {
    const roles = this.getRoles();
    const roleData = roles.find(r => r.value === role);
    return roleData ? roleData.permissions : [];
  }
}

export const userService = new UserService();
